import React, { Component } from 'react';
import styled, {css, keyframes} from 'styled-components';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { AnimatePresence } from "framer-motion"
import Measure from 'react-measure'
import { format,sub,isEqual } from 'date-fns'
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';
import moment from 'moment-timezone';

import { Button, Paper, ListTile, Animation } from 'components'
import { FaBell, FaMinus, FaAngleLeft } from 'react-icons/fa'
import AlertOptions from './AlertOptions'
import { Toast, Alert } from 'schema'
import { datetimeString, alertConverter, formatDateTime, momentDate } from 'utils'

import * as actionCreators from 'store/actions'

const defaultStyle = {
    backgroundColor: 'var(--secondary-color)',
    padding: '0.5rem',
    width: 'var(--popout-width)'
}

const inlineStyle = {
    backgroundColor: 'var(--secondary-color)',
    padding: '0',
    width: 'auto'
}

const Container = styled.div`
    border-radius: 5px;
    background-color: ${props => props.style.backgroundColor};
    padding: ${props => props.style.padding};
    width: ${props => props.style.width};
    overflow: hidden;
    position: relative;
`

const Header = styled.div`
    grid-template-columns: 2rem auto 2rem;
    display: grid;
    justify-items: center;
    align-items: start;
    margin: 0.3rem 0;
`

// const Title = styled.div`
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     margin-bottom: 0.5rem;
//     font-weight: bolder;
//     font-size: 0.9rem;
// `

const Title = styled.div`
    font-weight: bolder;
    font-size: 0.7rem;
    text-transform: uppercase;
    color: var(--secondary-accent-color);
    margin-bottom: 0.2rem;
`

const Subtitle = styled.div`
    font-size: 0.8rem;
    filter: brightness(var(--brightness));
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 0.5rem;
`


class AlertInput extends Component {
    constructor(props){
        super(props);
        this.style = Object.assign({}, this.props.inline ? inlineStyle : defaultStyle, this.props.style)
        this.state = {
            type: this.props.type || 'time',
            // alerts: this.props.alerts || [this.props.date],
            alerts: this.props.alerts || [], // List of alerts, not dates
            content: null,
            boundingRect: null,
            targetAlert: null
        }
        console.log({type: this.props.type, alerts: this.props.alerts, date: this.props.date})

        // Reference date
        let refDate = this.props.date || moment().tz(this.props.timezone).set({hour: 0, minute: 0, second: 0})
        // this.date = datetimeString(refDate, this.props.type)
        this.date = formatDateTime(refDate)

        // Button styles
        this.buttonStyle = {
            backgroundColor: 'var(--secondary-color)', 
            // hoverColor:'var(--text-color)', 
            margin:'0rem', padding:'0.2rem', fontSize:'0.7rem',
            color: 'white',
            boxShadowColor: 'transparent'
        }
        this.exitButtonStyle = {
            backgroundColor:'var(--secondary-color)',
            margin:'0',
            boxShadowColor: 'transparent',
            padding: '0.4rem',
            color: 'var(--secondary-accent-color)'
        }
    }

    getBlocks = () => {
        let blocks = []
        let alertBlocks = {}
        
        this.state.alerts.map(alert => {
            const item = alert && this.props.data['items'][alert['secID']['id']]
            if(item && item.hasSchedule()){
                const itemDate = momentDate(item['start_time'] || item['end_time'] || item['start_date'] || item['end_date'], this.props.timezone)
                const distance = alert.getDistance(itemDate, this.props.timezone)
                const block = <ListTile text={distance['distance']} trailingPersist onSelect={() => console.log(alert)}
                                trailingIcon={
                                    !itemDate.isSame(distance['date'])
                                    ? <Button icon={<FaMinus/>} styles={this.buttonStyle} onSelect={() => this.deleteAlert(alert)}/>
                                    : null}/>
                alertBlocks[alert['alertID']] = {
                    date: distance['date'],
                    block: block
                }
            }
        })

        alertBlocks = _.sortBy(alertBlocks, ['date']).reverse()
        blocks = alertBlocks.map(block => (block['block']))

        return blocks
    }

    addAlert = (value) => {
        // Convert new alert into date
        let duration = {}
        duration[value.metric] = value.value
        const newDate = this.props.date.subtract(duration)
        let updatedAlerts = [...this.state.alerts]

        // Compare new alert date with existing alerts
        const match = Object.values(this.state.alerts).some(alert => alert && _.isEqual(alert['reference'], value))

        // Add to state if new alert doesn't exist
        if(!match){
            const newAlert = new Alert({
                date: newDate, 
                reference: value,
                userID: this.props.userID,
                secID: this.props.secID,
                title: this.props.title,
            })
            
            updatedAlerts.push(newAlert)
            updatedAlerts = _.filter(updatedAlerts, Boolean)
            

            // Pass back to ItemOptions
            this.props.onSelect(updatedAlerts)
        }
        this.setState({content: 'main', alerts: updatedAlerts, targetAlert: null})
    }

    deleteAlert = (alert) => {
        let updatedAlerts = [...this.state.alerts]
        const index = Object.values(this.state.alerts).indexOf(alert)
        updatedAlerts.splice(index, 1)
        this.setState({
            alerts: updatedAlerts
        })
        console.log('delete alert', updatedAlerts)
        this.props.onSelect(updatedAlerts)
    }

    render() {
        let content = null
        const blocks = this.getBlocks()
        switch(this.state.content){
            case 'main':
                content = 
                <Animation key='main' animation='exitRight' boundingRect={this.state.boundingRect}>
                    <Header>
                        <Button icon={<FaAngleLeft/>} onSelect={this.props.onClose} styles={this.exitButtonStyle}/>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            <Title>Reminders</Title> 
                            <Subtitle>{this.date}</Subtitle>
                        </div>
                    </Header>
                    {blocks}
                    <Button text='Add alert' styles={{backgroundColor:'var(--focus-color)', width: 'fit-content', color: 'white'}} onSelect={() => {this.setState({content: 'options'})}}/>
                </Animation>
                break

            case 'options':
                content = 
                <AnimatePresence key='options'>
                    <Animation key='options' animation='slideLeft'boundingRect={this.state.boundingRect}>
                        <Header>
                            <Button icon={<FaAngleLeft/>} onSelect={() => {this.setState({content: 'main'})}} styles={this.exitButtonStyle}/>
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                <Title>Reminders</Title> 
                                <Subtitle>{this.date}</Subtitle>
                            </div>
                        </Header>
                        
                        <AlertOptions type={this.props.type} onSelect={this.addAlert}/>
                    </Animation>
                </AnimatePresence>
                break
            
            default:
                content =
                <AnimatePresence key='default'>
                    <Animation key='defult' boundingRect={this.state.boundingRect}>
                        <Header>
                            <Button icon={<FaAngleLeft/>} onSelect={this.props.onClose} styles={this.exitButtonStyle}/>
                            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                <Title>Reminders</Title> 
                                <Subtitle>{this.date}</Subtitle>
                            </div>
                        </Header>

                        {blocks}
                        <Button text='Add alert' styles={{backgroundColor:'var(--focus-color)', width: 'fit-content', color: 'white'}} onSelect={() => {this.setState({content: 'options'})}}/>
                    </Animation>
                </AnimatePresence>
        }
        
        const finalContent = 
        <Measure
            bounds
            onResize={contentRect => {
                this.setState({ boundingRect: contentRect.bounds })
            }}>
            {({ measureRef }) => (
                <Container ref={measureRef} style={this.style}>{content}</Container>
            )}
        </Measure>
        
        if(this.props.inline){
            return (<div>{finalContent}</div>)
        } else {
            return (<Paper margin='0.5rem 0'>{finalContent}</Paper>)
        }
    }
    

}

const mapStateToProps = state => {
    return {
        uid: state.auth.uid,
        data: state.db.present.data && state.db.present.data.toJS(),
        inputID: state.content.inputID
    }
};

const mapDispatchToProps = dispatch => {
    return {
        
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertInput);

AlertInput.propTypes = {
    inline: PropTypes.bool,
    type: PropTypes.oneOf(['day','time']),
    alerts: PropTypes.arrayOf(PropTypes.string),
    onClose: PropTypes.func,
};